import styled from 'styled-components';
export var StyledHighlighter = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledHighlighter",
  componentId: "c11n-8-107-0__sc-uzdygj-0"
})([""]);